import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faq";

export default function FaqPage() {
  const [openSet, setOpenSet] = useState<number[]>([0]);

  const toggle = (i: number) => {
    setOpenSet((prev) => (prev.includes(i) ? prev.filter((x) => x !== i) : [...prev, i]));
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        })}
      </script>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-10">
        {/* breadcrumb */}
        <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
          <Link to="/" className="hover:text-primary-700 cursor-pointer">首页</Link>
          <i className="ri-arrow-right-s-line text-foreground-300" />
          <span className="text-foreground-700">常见问题</span>
        </nav>

        <div className="mt-8 grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* intro */}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                <i className="ri-question-line" />
                常问常答
              </span>
              <h1 className="mt-4 font-display text-3xl font-black text-foreground-950 md:text-4xl">
                常见问题
              </h1>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                关于瓜单可信度、补课姿势、投稿规则与更新频率，这里一次性讲清楚。没有你要的答案？欢迎直接投稿或来信。
              </p>

              <div className="mt-6 rounded-2xl border border-background-200 bg-background-100/60 p-5">
                <div className="flex items-center gap-2">
                  <i className="ri-customer-service-2-line text-xl text-primary-600" />
                  <h2 className="font-display text-base font-bold text-foreground-900">还是想问别的？</h2>
                </div>
                <p className="mt-2 text-sm text-foreground-600">把问题或线索告诉编辑部，我们会尽量回复。</p>
                <Link
                  to="/about#contact"
                  className="mt-4 inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600 cursor-pointer"
                >
                  <i className="ri-send-plane-line" />
                  联系我们
                </Link>
              </div>
            </div>
          </div>

          {/* faq list */}
          <div className="lg:col-span-8">
            <div className="space-y-3">
              {faqs.map((f, i) => {
                const open = openSet.includes(i);
                return (
                  <div key={f.q} className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
                    <button
                      type="button"
                      onClick={() => toggle(i)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left cursor-pointer hover:bg-background-100/50"
                    >
                      <h3 className="flex items-center gap-3 text-[15px] font-bold text-foreground-900">
                        <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-display text-sm font-black ${open ? "bg-primary-500 text-background-50" : "bg-primary-100 text-primary-700"}`}>
                          Q{i + 1}
                        </span>
                        {f.q}
                      </h3>
                      <i className={`ri-arrow-down-s-line shrink-0 text-xl transition-transform ${open ? "rotate-180 text-primary-600" : "text-foreground-400"}`} />
                    </button>
                    <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                      <div className="overflow-hidden">
                        <p className="border-t border-background-200 px-4 py-4 pl-14 text-sm leading-relaxed text-foreground-600">
                          {f.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mt-8 flex flex-col items-center justify-between gap-3 rounded-2xl bg-gradient-to-r from-primary-600 to-primary-500 p-5 text-background-50 sm:flex-row sm:px-7">
              <p className="font-display text-base font-bold sm:text-lg">想让某个瓜也出现在瓜单里？</p>
              <Link
                to="/about#contact"
                className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-background-50 px-5 py-2.5 text-sm font-semibold text-primary-700 hover:bg-background-100 cursor-pointer"
              >
                <i className="ri-flashlight-line" />
                去投稿线索
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}